// eslint-disable-next-line no-unused-vars
import * as XLSX from 'xlsx';

export default class Worksheet {
  /**
   * @param {XLSX.WorkSheet} ws
   * @param {array<Object>} rows
   * @returns {void}
   */
  constructor(ws, rows) {
    this.ws = ws;
    this.rows = rows;
  }

  /** @returns {Array<string>} */
  getHeaders() {
    return Object.keys(this.rows[0]);
  }

  /**
   * @param {string} cell
   * @returns {string}
   */
  getCellValue(cell) {
    const { v } = this.ws[cell.toUpperCase()];
    return v;
  }

  /**
   * @param {string} column
   * @param {*} value
   * @returns {object|undefined}
   */
  searchRowFromColumn(column, value) {
    return this.rows.find((row) => row[column] === value);
  }

  /**
   * @param {Function} cb
   * @returns {void}
   */
  forEachRow(cb) {
    Object.values(this.rows).forEach(cb);
  }
}
